import { render, staticRenderFns } from "./HomeGoodsNew.vue?vue&type=template&id=65a26118&scoped=true&"
import script from "./HomeGoodsNew.vue?vue&type=script&lang=js&"
export * from "./HomeGoodsNew.vue?vue&type=script&lang=js&"
import style0 from "./HomeGoodsNew.vue?vue&type=style&index=0&id=65a26118&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a26118",
  null
  
)

export default component.exports